import { Link } from 'react-router-dom';
import { PortalShell } from '@/layouts/PortalShell/PortalShell';
import { FooterChrome } from '@/layouts/FooterChrome/FooterChrome';
import { nb } from '@/i18n/nb';
import s from './Personvern.module.css';

export function Personvern() {
  return (
    <PortalShell>
      <main className={s.page}>
        <h1 className={s.heading}>{nb.personvern.heading}</h1>
        <p className={s.body}>{nb.personvern.body}</p>
        <Link to="/" className={s.backLink}>
          {nb.personvern.backToFront}
        </Link>
      </main>
      <FooterChrome />
    </PortalShell>
  );
}
